import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { hideModal } from '../../../actions/_modal'
import { changePassword } from '../../../actions/account'
import { logoutAndRedirect, userNeedsToResetPassword } from '../../../actions/auth'
import { fetchDataAndRedirectUser } from '../../../actions/combined'
import LoadingSpinner from '../../mini/LoadingSpinner'
import Modal from '../../mini/Modal'
import Password from '../../mini/Password'
import UserAvatar from '../../mini/UserAvatar'
import { H2, H5 } from '../../styled/typography/typography'
import {
  P2ChangePassword,
  CobaltTextChangePassword,
  ChangePasswordError 
} from './_Styled'
import VoluntaryChange from './VoluntaryChange'

export class ChangePassword extends Component {
  constructor (props) {
    super(props)

    this.state = {
      currentPassword: '',
      password: '',
      isContinuing: false
    }

    this.checkForSubmitBound = this.checkForSubmit.bind(this)
    this.handleCurrentPasswordChangeBound = this.handleCurrentPasswordChange.bind(this)
    this.handlePasswordChangeBound = this.handlePasswordChange.bind(this)
    this.onChangePasswordClickBound = this.onChangePasswordClick.bind(this)
    this.shouldButtonBeDisabledBound = this.shouldButtonBeDisabled.bind(this)
    this.onContinueClickBound = this.onContinueClick.bind(this)
    this.onReturnToLoginClickBound = this.onReturnToLoginClick.bind(this)
  }

  render () {
    const {
      wasPasswordChanged,
      user,
      changePasswordErrorMessage
    } = this.props

    return (
      <Modal
        top={50}
        width={600}
        height={!wasPasswordChanged ? 490 : 315}
        background='#f5f5f5'
        borderRadius='5px'
        boxShadow='0px 0px 9px 0px rgba(0, 0, 0, 0.08)'
        opacity='1.0'>
        <div className='change-password'>
          {!wasPasswordChanged ? (
            <React.Fragment>
              <UserAvatar
                size={38}
                borderRadius={5}
                photoUrl={user.photo.url}
              />
              <H2>
                Before you continue, please<br />
                change your password.
              </H2>
              <P2ChangePassword>
                Use something unique and memorable.
              </P2ChangePassword>
              <div className='form'>
                <div className='row'>
                  {changePasswordErrorMessage &&
                    <ChangePasswordError>{changePasswordErrorMessage}</ChangePasswordError>
                  }
                  <H5 className='label'>Current Password</H5>
                  <Password
                    className='password'
                    placeholder='Current password'
                    onChange={this.handleCurrentPasswordChangeBound}
                    onKeyPress={this.checkForSubmitBound} />
                </div>
                <div className='row'>
                  <H5 className='label'>New Password</H5>
                  <Password
                    className='password'
                    placeholder='New password'
                    onChange={this.handlePasswordChangeBound}
                    onKeyPress={this.checkForSubmitBound}
                    showHint />
                </div>
              </div>
              <div
                className={`quest-btn btn-a go ${this.shouldButtonBeDisabledBound() ? 'disabled' : 'active'}`}
                onClick={!this.shouldButtonBeDisabledBound() ? this.onChangePasswordClickBound : null}>
                Change Password
              </div>
              <CobaltTextChangePassword
                onClick={this.onReturnToLoginClickBound}>
                Return to Login
              </CobaltTextChangePassword>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className='checked'/>
              <H2>
                Success! You changed your password.
              </H2>
              <P2ChangePassword>
                Remember to use your new password the next time you log in.
              </P2ChangePassword>
              {!this.state.isContinuing ? (
                <div
                  className='quest-btn btn-a continue'
                  onClick={this.onContinueClickBound}>
                  Continue
                </div>
              ) : (
                <LoadingSpinner isSmall />
              )}
            </React.Fragment>
          )}
        </div>
      </Modal>
    )
  }

  checkForSubmit (e) {
    if ((e.which === 13 || e.keyCode === 13) && !this.shouldButtonBeDisabledBound()) {
      this.onChangePasswordClick(e)
    }
  }

  handleCurrentPasswordChange (e) {
    this.setState({ currentPassword: e.target.value.trim() })
  }

  handlePasswordChange (e) {
    this.setState({ password: e.target.value.trim() })
  }

  shouldButtonBeDisabled () {
    return this.state.password.length < 8 || this.state.currentPassword.length < 1
  }

  onChangePasswordClick () {
    this.props.dispatch(changePassword(this.state.currentPassword, this.state.password))
  }

  onReturnToLoginClick () {
    this.props.dispatch(logoutAndRedirect())
  }

  async onContinueClick () {
    const user = Object.assign({}, this.props.user)
    user.require_password_change_on_next_login = false

    let currentOrg = user.organizations.find(org => org.id === user.org_id)
    const isMentor = currentOrg.roles.includes("qa_mentor")

    this.setState({
      isContinuing: true
    })

    await this.props.dispatch(fetchDataAndRedirectUser(user, currentOrg, isMentor))
    this.props.dispatch(userNeedsToResetPassword(false))
    this.props.dispatch(hideModal())
  }
}

ChangePassword.propTypes = {
  dispatch: PropTypes.func,
  user: PropTypes.object,
  wasPasswordChanged: PropTypes.bool,
  changePasswordErrorMessage: PropTypes.string
}

export const mapStateToProps = (state) => ({
  user: state.auth.user,
  wasPasswordChanged: state.account.wasPasswordChanged,
  changePasswordErrorMessage: state.account.changePasswordErrorMessage
})

export default connect(mapStateToProps)(ChangePassword)
